const newSearchModel = require('./model/searchModel');
const newResultsModel = require('./model/resultsModel');
const {
    readOnlyModelProperty,
    queryParser,
} = require('gui');

module.exports = function model() {
    const c = {};
    const searchValue = queryParser.get('traceNo');
    c.search = newSearchModel(searchValue);
    c.results = newResultsModel();
    c.isSearching = readOnlyModelProperty(!!searchValue);
    c.hasSearched = readOnlyModelProperty(false);

    return c;
}
